import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import "../Dashboard/Dashboard.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";

import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid } from "uuid";
import {
  fetchStatus,
  isSuperAdmin,
  isUserAdmin,
  requestLoading,
  stylesofStype,
} from "../../utils/comman/Common";
import { ShowAllDetails } from "../Model/ShowAllDetails";
import { fetchpagedata, fetchreport } from "./apicallfunction";
import Tablegrid from "./table-list";
import Aepshead from "./aepshead";
import Aepspagination from "./aepspagination";
import moment from "moment";

const AEPSService = () => {
  const requesterId = useSelector(
    (state) => state.selectedretailerReqesterReducer.requesterId
  );
  const currentDate = moment().format("YYYY-MM-DD");
  const nextDate = moment().add(1, 'day').format('YYYY-MM-DD')
  const [axiosInstance] = axiosinstances();
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  //console.log('selectedId', selectedId)
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [statusOption, setStatusOption] = useState([
    { value: "SUCCESS", label: "SUCCESS" },
    { value: "ACCEPTED", label: "ACCEPTED" },
    { value: "PENDING", label: "PENDING" },
    { value: "INTERNAL_FAILURE", label: "INTERNAL_FAILURE" },
    { value: "PROCESSING", label: "PROCESSING" },
    { value: "HUNG", label: "HUNG" },
    { value: "FAILED", label: "FAILED" },
    { value: "AUTO_REVERSED", label: "AUTO_REVERSED" },
    { value: "MANUALLY_REVERSED", label: "MANUALLY_REVERSED" },
    { value: "SUCCESS_TO_FAILED", label: "SUCCESS_TO_FAILED" },
  ]);
  const [txnCategryOption, setTxnCategryOption] = useState([
    { value: "AEPS_CASHOUT", label: "AEPS_CASHOUT" },
    { value: "AEPS_MINI_STATEMENT", label: "AEPS_MINI_STATEMENT" },
    { value: "AEPS_BALANCE_ENQUIRY", label: "AEPS_BALANCE_ENQUIRY" },
  ]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTxnCat, setSelectedTxnCat] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  //setFinalSelectedtxnCat
  const [finalSelectedtxnCat, setFinalSelectedtxnCat] = useState();
  const [showModal, setShowModel] = useState(false);
  const [firstSelectedPage, setFirstSelectedPage] = useState();
  const [secondSelectedPage, setSecondSelectedPage] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [updatedFormDate, setUpdatedFormDate] = useState("");
  const [updatedToDate, setUpdatedToDate] = useState("");
  const [selectOption, setSelectOption] = useState("");
  const [pageStart, setpageStart] = useState(0);
  const [pagelimit, setPagelimit] = useState(0);
  const [customPage, setCustomPage] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [transactionStatuswithAmount, setTransactionStatuswithAmount] = useState([])
  const [table, settable] = useState([]);
  const [isclearClicked, setIsclearClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedDataToShow, setSelectedDataToShow] = useState({});
  const [showModalDetails, setShowModelDetails] = useState(false);
  //console.log('pageStart', pageStart)

  useEffect(() => {
    if (Array.isArray(selectedTxnCat) && selectedTxnCat.length > 0) {
      const values = selectedTxnCat.map((val) => val.value);
      setFinalSelectedtxnCat(values);
    } else if (Array.isArray(selectedTxnCat) && selectedTxnCat.length === 0) {
      setFinalSelectedtxnCat([]);
    }
  }, [selectedTxnCat]);
  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);
  useEffect(() => {
    if (selectOption === "All" && firstSelectedPage !== undefined) {
      setpageStart(1);
      setPagelimit(firstSelectedPage);
    } else if (
      selectOption == "Custom" &&
      firstSelectedPage !== undefined &&
      secondSelectedPage !== undefined
    ) {
      setpageStart(firstSelectedPage);
      setPagelimit(secondSelectedPage);
    }
  }, [selectOption, firstSelectedPage, secondSelectedPage]);
  //console.log('finalSelectedStatus', finalSelectedStatus)
  const Transactiontable = useSelector(
    (state) => state.transactionhistoryreducer.Transaction
  );
  const a = useSelector((state) => state.transactionhistoryreducer.Transaction);
  const responseobject = useSelector(
    (state) => state.getclaimdatareducer.getclaimdata
  );
  const url = `/api/v1/aeps/order/history/mis`
  useEffect(() => {
    const pageindex = 0;
    
    if (id) {
      //console.log('bbbbbb')
      // fetchpagedata(0,id,isUserAdmin(id), selectedId)
      fetchpagedata(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        requesterId,
        uuid,
        formDate,
        toDate,
        finalSelectedStatus,
        finalSelectedtxnCat,
        settable,
        setPaginationDetails,
        setIsDataLoaded,
        e,
        toast
      );
      fetchStatus(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      )
    }
    // else if(id && !isUserAdmin(id)) {
    //   //console.log('aaaaa')
    //   // fetchpagedata(0, id, isUserAdmin(id), selectedId)
    //   fetchpagedata(
    //     pageindex,
    //     id,
    //     isUserAdmin(id),
    //     selectedId,
    //     setDataLoading,
    //     setsearch,
    //     axiosInstance,
    //     id,
    //     requesterId,
    //     uuid,
    //     isAdmin,
    //     selectedId,
    //     pageindex,
    //     formDate,
    //     toDate,
    //     finalSelectedStatus,
    //     finalSelectedtxnCat,
    //     settable,
    //     setDataLoading,
    //     setPaginationDetails,
    //     setIsDataLoaded
    //     )
    // }
  }, [id, selectedId]);

  const [pageindex, setpageindex] = useState("");

  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });
    setpageindex(index);
    setpageindex((ind) => {
      return ind;
    });
    if (isUserAdmin(id) && selectedId !== null) {
      // fetchpagedata(index-1,id,isUserAdmin(id), selectedId)
      const pageindex = index - 1;
      fetchpagedata(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        requesterId,
        uuid,
        formDate,
        toDate,
        finalSelectedStatus,
        finalSelectedtxnCat,
        settable,
        setPaginationDetails,
        setIsDataLoaded,
        e,
        toast
      );
    } else {
      //  fetchpagedata(index - 1, id, isUserAdmin(id))
      const pageindex = index - 1;
      fetchpagedata(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        requesterId,
        uuid,
        formDate,
        toDate,
        finalSelectedStatus,
        finalSelectedtxnCat,
        settable,
        setPaginationDetails,
        setIsDataLoaded,
        e,
        toast
      );
    }
  };
  const totalpage = paginationDetails.totalPages;
  //console.log('paginationDetails', paginationDetails)
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search, id);
    settable(() => callingsearchapi.orders);
  };

  const searchapidata = async (search, id) => {
    const trimSearch = search.trim();
    setDataLoading(true);
    const response = await axiosInstance
      .get(`/api/v1/aeps/order/search/${trimSearch}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        setDataLoading(false);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const enterTxnsearch = (event) => {
    event.preventDefault();
    setsearch(event.target.value);
    setSearchTyping(true);
  };

  // const myArray = Array.apply(null, { length: totalpage }).map(
  //   Number.call,
  //   Number
  // );
  //console.log('myArray', myArray)

  const onExportData = async () => {
    // setShowModel(true)
    const pageindex = 0;
    const data = await fetchreport(
      pageindex,
      id,
      isUserAdmin(id),
      selectedId,
      setDataLoading,
      setsearch,
      axiosInstance,
      requesterId,
      uuid,
      formDate,
      toDate,
      finalSelectedStatus,
      finalSelectedtxnCat,
      settable,
      setPaginationDetails,
      setIsDataLoaded,
      e,
      toast,
      FileSaver
    );
  };

  // const closePopUp = () =>{
  //   setShowModel(false)
  //   setFirstSelectedPage()
  //   setSecondSelectedPage()
  //   setCustomPage('')
  //   setSelectOption('')
  // }

  // const reverse = ['AUTO_REVERSED','MANUALLY_REVERSED']
  // const callApiReversalRepoertApi = (e)=>{
  //   e.preventDefault()
  //   setLoading(true)
  //   if (isUserAdmin(id) && selectedId !== null){

  //     exportReversalReport(0,id,isUserAdmin(id),reverse)
  //     } else{
  //        exportReversalReport(0,id,isUserAdmin(id),reverse)
  //    }
  // }
  // async function exportReversalReport(pageindex, id, isAdmin, finalSelectedStatus,finalSelectedtxnCat){
  //   await  axiosInstance
  //     .post(`/api/v1/aeps/order/history`, {
  //       header: {
  //         "client-id": id,
  //         role: "ROLE_RETAILER_FINXPAY",
  //         "msgType" : "ORDER_HISTORY",
  //         "channel" :  "ADMIN",
  //         "requesterId" : requesterId,
  //         "time" : new Date()
  //       },
  //       device: null,
  //       agentId: isAdmin ? selectedId :id,
  //       pageNo: pageindex,
  //       startDate: formDate,
  //       endDate: toDate,
  //       status: finalSelectedStatus !== undefined && finalSelectedStatus.length !==0 ? finalSelectedStatus : null ,
  //       txnCategory: finalSelectedtxnCat !== undefined && finalSelectedtxnCat.length !==0 ? finalSelectedtxnCat : null ,
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${e}`,
  //         "client-id": id,
  //         role: "ROLE_RETAILER_FINXPAY",
  //       },
  //     })
  //    .then((res) => {
  //     getExportFile(res.data?.totalPages !== undefined ? res.data?.totalPages : 0)
  //    })
  //    .catch((err) => {
  //      //console.log(err);
  //      toast.error("Something went wrong");
  //      setLoading(false)
  //    });

  // }
  // const getExportFile = async (allpagenum) =>{

  //   let result=[]
  //   //console.log('allpagenum',allpagenum)
  //   for(let i = 0; i < allpagenum; i++){
  //     //console.log('index1', i)
  //     const  data =  await fetchreport(i,id,isUserAdmin(id),reverse,finalSelectedtxnCat);
  //     if(Array.isArray(data?.orders)){
  //      const unwantedHeaderForExcel = data.orders.filter(val=>{
  //       const updatedon = new Date(val.updatedOn)
  //       const newfromDate = new Date(updatedFormDate)
  //       const newToDate = new Date(updatedToDate)
  //        return updatedon > newfromDate && updatedon < newToDate
  //        }).map(val=>{
  //         val.notes = val.notes !==null && val.notes !== undefined ?  val.notes[0] : ''
  //         val.operator = val.transaction.operator
  //         val.amount = val.transaction.amount
  //           delete val.transaction
  //           delete val.optional

  //           delete val.paymentChangeLog
  //           delete val.paymentRefId
  //           delete val.paymentTxnId
  //           delete val.requestId

  //           delete val.requesterId
  //           delete val.statusChangeLog
  //           delete val.supplierId

  //           delete val.supplierUrl
  //           delete val.txnDetails
  //           delete val.walletBalance
  //           delete val.walletCreditLimit
  //           delete val.walletLien
  //           const newvalues = val
  //           return newvalues
  //        })
  //       result.push(...unwantedHeaderForExcel)
  //     }
  //   }

  //   const csv = convertArrayToCSV(result)
  //   const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  //   FileSaver.saveAs(csvData, 'data.csv');
  //   closePopUp()
  //   setLoading(false)
  // }
  const callApi = () => {
    const pageindex = 0;
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        requesterId,
        uuid,
        formDate,
        toDate,
        finalSelectedStatus,
        finalSelectedtxnCat,
        settable,
        setPaginationDetails,
        setIsDataLoaded,
        e,
        toast
      );
      fetchStatus(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      )
    } else {
      fetchpagedata(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        requesterId,
        uuid,
        formDate,
        toDate,
        finalSelectedStatus,
        finalSelectedtxnCat,
        settable,
        setPaginationDetails,
        setIsDataLoaded,
        e,
        toast
      );
      fetchStatus(
        pageindex,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      )
    }
  };
  const clearSearch = () => {
    setsearch("");
    setSearchTyping(false);
    callApi();
  };
  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    callApi();
  };
  //console.log('finalSelectedStatus', finalSelectedStatus)
  useEffect(() => {
    if (
      finalSelectedStatus !== undefined &&
      finalSelectedStatus.length == 0 &&
      isclearClicked
    ) {
      callApi();
    }
  }, [finalSelectedStatus, isclearClicked]);
  const resetApply = () => {
    setFinalSelectedStatus([]);
    setFinalSelectedtxnCat([]);
    setSelectedTxnCat([]);
    setSelectedStatus([]);
    setIsExportable(false);
    setFormDate("");

    setToDate("");
    setUpdatedFormDate("");
    setUpdatedToDate("");
    setIsclearClicked(true);
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };

  //updatedFromDateHandler updatedToDateHandler
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };
  //setSelectedTxnCat
  const changeTxnCatHandler = (select) => {
    setSelectedTxnCat(select);
  };
  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (
      finalSelectedtxnCat !== undefined &&
      finalSelectedtxnCat.length > 0
    ) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  //revcheckDisable
  const revcheckDisable = () => {
    let disabled = true;
    if (
      formDate !== "" &&
      toDate !== "" &&
      updatedFormDate !== "" &&
      updatedToDate !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };
  const showAllData = (data) => {
    setSelectedDataToShow({ ...data });
    setShowModelDetails(true);
  };
  const closeDetailsPopUp = () => {
    setShowModelDetails(false);
  };
  //console.log('myArray', myArray)
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <ShowAllDetails
            showModal={showModalDetails}
            closePopUp={closeDetailsPopUp}
            data={selectedDataToShow}
          />
          <div class="mid">
            <div class="container-fluid">
              <div class="maincard">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link active"
                    id="mobile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-mobi"
                    type="button"
                    role="tab"
                    aria-controls="nav-mobi"
                    aria-selected="true"
                  >
                   AEPS Transactions
                  </button>
                </div>

                <div class="tab-content" id="mobiletab">
                  <div
                    class="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <Aepshead
                      applyStatus={applyStatus}
                      Select={Select}
                      stylesofStype={stylesofStype}
                      txnCategryOption={txnCategryOption}
                      changeTxnCatHandler={changeTxnCatHandler}
                      selectedTxnCat={selectedTxnCat}
                      statusOption={statusOption}
                      changeHandler={changeHandler}
                      selectedStatus={selectedStatus}
                      fromDateHandler={fromDateHandler}
                      formDate={formDate}
                      toDateHandler={toDateHandler}
                      toDate={toDate}
                      checkDisable={checkDisable}
                      resetApply={resetApply}
                      enterTxnsearch={enterTxnsearch}
                      search={search}
                      searchdata={searchdata}
                      clearSearch={clearSearch}
                      transactionStatuswithAmount={transactionStatuswithAmount}
                    />
                    <div class="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            <Tablegrid
                              table={table}
                              isSuperAdmin={isSuperAdmin}
                              id={id}
                              selectedId={selectedId}
                              isUserAdmin={isUserAdmin}
                              showAllData={showAllData}
                            />
                          )}

                          <Aepspagination
                            table={table}
                            search={search}
                            paginationDetails={paginationDetails}
                            isExportable={isExportable}
                            onExportData={onExportData}
                            handalpageclick={handalpageclick}
                          />
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="mobi-grap"
                    role="tabpanel"
                    aria-labelledby="mobi-grap-tab"
                  >
                    {/* <TransactionGraph/>  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default AEPSService;
